/**
 * URL allow-list sanitiser for scraped / external candidate URLs
 * (`cvUrl`, `photoUrl`, `linkedinUrl`, `xingUrl`, and `mailto:` targets)
 * before they reach an `href` attribute or `window.open`.
 *
 * React does NOT sanitise the `href` prop, so a scraped
 * `javascript:alert(1)` or `data:text/html,…` URL would execute when the
 * user clicks the link. `safeHttpUrl` returns the input only when it
 * parses as a URL AND its protocol is on the safe allow-list
 * (http / https / mailto); otherwise it returns `undefined` so the caller
 * can render plain, non-clickable text instead of a live link.
 */

const SAFE_PROTOCOLS = new Set(["http:", "https:", "mailto:"]);

export function safeHttpUrl(u?: string | null): string | undefined {
  if (u == null) return undefined;
  let protocol: string;
  try {
    // The base URL lets protocol-relative / relative inputs parse instead
    // of throwing. An absolute `javascript:` / `data:` URL keeps its own
    // scheme (the base is ignored) and is rejected by the allow-list below.
    protocol = new URL(u, "http://x").protocol;
  } catch {
    return undefined;
  }
  return SAFE_PROTOCOLS.has(protocol) ? u : undefined;
}
